{
  "export-issues-flyout-spotlight-tour.spotlight.body": [
    {
      "type": 0,
      "value": "Export your work items in the format you need, right from the more actions menu."
    }
  ],
  "export-issues-flyout-spotlight-tour.spotlight.heading": [
    {
      "type": 0,
      "value": "Export options have moved"
    }
  ],
  "export-issues-flyout-spotlight-tour.spotlight.okButton": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-issue-preview-panel.body": [
    {
      "type": 0,
      "value": "Open work items in a side panel to stay focused on your table."
    }
  ],
  "jira-nin-issue-preview-panel.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-issue-preview-panel.heading": [
    {
      "type": 0,
      "value": "Stay in context with preview panel"
    }
  ],
  "jira-nin-issue-preview-panel.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-issue-preview-panel.show-me": [
    {
      "type": 0,
      "value": "Show me"
    }
  ],
  "jira-nin-issue-preview-panel.show-me-aria-label": [
    {
      "type": 0,
      "value": "Open this issue in the preview panel"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription": [
    {
      "type": 0,
      "value": "Want us to apply your current filter and group settings to this new List view?"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo": [
    {
      "type": 0,
      "value": "No"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes": [
    {
      "type": 0,
      "value": "Yes"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.description": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. A new List view."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription": [
    {
      "type": 0,
      "value": "Any existing filters and groups will be applied."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.learnMoreLink": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.body": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. A new List view."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label": [
    {
      "type": 0,
      "value": "Explore List view"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.filter": [
    {
      "type": 0,
      "value": "One place to search work and filter results to find what you need."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions": [
    {
      "type": 0,
      "value": "Dive deeper - view work items as a chart, use format rules to highlight key work, and more."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.body": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience."
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more": [
    {
      "type": 0,
      "value": "Tell me more"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.description.filter": [
    {
      "type": 0,
      "value": "You can now filter work items by status and priority, making it easier to find work."
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.description.improvements": [
    {
      "type": 0,
      "value": "More improvements to come."
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.description.parent": [
    {
      "type": 0,
      "value": "Use the parent filter to search for epics, as well as any other work items with child work items."
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.page2.title": [
    {
      "type": 0,
      "value": "We've updated epic to parent"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.title": [
    {
      "type": 0,
      "value": "Introducing a new home for filters"
    }
  ]
}